var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4157 6.67891C20.4459 7.77257 20.9991 9 20.9991 10.9897C20.9991 14.4891 18.5426 17.6263 14.9685 19.1768L14.0758 17.7992C17.4111 15.9946 18.0629 13.6539 18.3235 12.178C17.7865 12.4557 17.0835 12.5533 16.3944 12.4895C14.59 12.3222 13.1679 10.8409 13.1679 9C13.1679 7.067 14.7349 5.5 16.6679 5.5C17.741 5.5 18.7671 5.99045 19.4157 6.67891ZM9.41571 6.67891C10.4459 7.77257 10.9991 9 10.9991 10.9897C10.9991 14.4891 8.54261 17.6263 4.96853 19.1768L4.07584 17.7992C7.41108 15.9946 8.06294 13.6539 8.32349 12.178C7.78649 12.4557 7.08354 12.5533 6.39441 12.4895C4.59004 12.3222 3.16797 10.8409 3.16797 9C3.16797 7.067 4.73497 5.5 6.66797 5.5C7.74102 5.5 8.76716 5.99045 9.41571 6.67891Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackquote);
export default __webpack_public_path__ + "static/media/blackquote.233e06c94da6e86782e28edc05608253.svg";
export { ForwardRef as ReactComponent };